import { useDispatch } from 'react-redux';
import { createQrsWave } from '../thunks/create-qrs-wave.thunk';
import { setWaveTimestamp } from '../thunks/set-wave-timestamp.thunk';

export const useQrsHandler = () => {
  const dispatch = useDispatch();

  return (eventType: keyof WindowEventMap, timestamp: number) => {
    switch (eventType) {
      case 'click':
        dispatch(createQrsWave(timestamp));
        break;

      case 'mousemove':
        dispatch(setWaveTimestamp(timestamp));
        break;
    }
  };
};
